<generic-search-results
    [showHeader]="false"
    [showCounter]="false"
    [title]="''"
    [records]="approleAssignments"
    [displayedColumns]="displayColumns"
    [selectableRecords]="false"
    [allowLocalFilter]="false"
></generic-search-results>